import { UILicense } from '@features/licenses/interfaces';
import { TableColumn } from '@shared/interfaces';

/**
 * The columns data for the licenses table.
 */
export const LICENSE_COLUMNS_TAB: TableColumn[] = [
    { field: 'screenshot', header: 'Screenshot', width: '120px', type: 'image' },
    {
        field: 'displayStatus',
        header: 'Display Status',
        width: '150px',
        type: 'status',
        color: '#8DCB2C',
    },
    {
        field: 'licenseKey',
        header: 'License Key',
        width: '250px',
        type: 'status-copy',
        hasRedirect: true,
    },
    { field: 'dealer', header: 'Dealer', width: '200px', type: 'copy' },
    { field: 'host', header: 'Host', width: '200px' },
    { field: 'anydesk', header: 'Anydesk', width: '200px' },
    { field: 'alias', header: 'Alias', width: '150px' },
    { field: 'installationDate', header: 'Installation Date', width: '150px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '150px',
        type: 'actions',
        actions: [
            { icon: 'export', name: 'export' },
            { icon: 'screens', name: 'screens' },
            { icon: 'delete', name: 'delete' },
            { icon: 'chevron', name: 'details' },
        ],
    },
];
